import { render, staticRenderFns } from "./BellaItalia.vue?vue&type=template&id=12bbbed2&"
import script from "./BellaItalia.vue?vue&type=script&lang=js&"
export * from "./BellaItalia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports